import { validate_email, validate_phone_number } from "@/utils/validations.js";
import CustomTabs from '@/components/CustomTab/CustomTab.vue';
import SlideTabComponent from "@/components/SlideTab/SlideTabComponent.vue";
import { show_error } from "@/utils/validations.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";
import {
  serviceRules,
  defaultDataProcessing,
} from "@/utils/customer_data_rules";
import Swal from "sweetalert2";
import $ from "jquery";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import { defineAsyncComponent } from "vue";
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue';
import CustomerProfile from "./components/CustomerProfile.vue";
import AuditTrail from "./components/AuditTrail.vue";
import { fetchCustomerData } from "@/utils/fetch_customer_data.js";

export default {
  name: "ClientAdminUsers",
  components: {
    NavBar: defineAsyncComponent(() =>
      import("@/components/NavBar/NavBar.vue")
    ),
    RiskMatrix: defineAsyncComponent({ loader: () => import("@/components/RiskMatrix/RiskMatrix.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    RerunService: defineAsyncComponent({ loader: () => import("./rerun_service/RerunService.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    CompanyCreditReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/company_credit_report/CompanyCreditReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    AMLReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/aml_reporting/AMLReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    ReportViewer: defineAsyncComponent({ loader: () => import("@/components/v2_report/ReportViewer.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    OcrVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/ocr_verification/OcrVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    OcrLivenessVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/ocr_liveness_verification/OcrLivenessVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    IdVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/id_liveness_verification/IdVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    AlternativeLivenessReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/alternative_verification/AlternativeVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    EnterpriseAmlVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/enterprise_aml/EnterpriseAmlVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    RefugeeVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/refugee_verification/RefugeeVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    EligibilitySolutionReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/eligibility_solution/EligibilitySolutionVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    BankStatementVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/finch_bank_statement/BankStatementVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    AddressVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/address_verification/AddressVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    AllInOneBankVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/all_in_one_bank_verification/AllInOneBankVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    RsaIdVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/rsa_id_verification/RsaIdVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    EmployeeScreeningData: defineAsyncComponent({ loader: () => import("./employee_screening/EmployeeScreeningData.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    AcademicCheckManagement: defineAsyncComponent({ loader: () => import("@/layouts/background_screening/academic_check/AcademicCheckManagement.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    HuruCriminalCheckManagement: defineAsyncComponent({ loader: () => import("@/layouts/background_screening/huru_criminal_check/HuruCriminalCheckManagement.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    IndividualBankAccountReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/bank_account_verification/individual_bank_account/IndividualBankAccountReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    IncomeEstimatorReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/income_estimator/IncomeEstimatorReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    IncomePredictorReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/income_predictor/IncomePredictorReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    DirectorScreeningReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/director_screening//DirectorScreeningReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    CompanyBankAccountReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/bank_account_verification/company_bank_account/CompanyBankAccountReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    TrustSearchReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/trust_search_report/TrustSearchReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    CreditReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/credit_report/CreditReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    MastercardReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/mastercard_report/MastercardReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    CipcReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/cipc_reporting/CIPCReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    IndividualLivenessReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/individual_liveness_verification/IndividualLivenessReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    EnterpriseKYBReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/enterprise_kyb/EnterpriseKYBReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    ComprehensiveLivenessVerificationReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/comprehensive_liveness_verification/ComprehensiveLivenessVerificationReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    AcademicPost92CheckReport: defineAsyncComponent({ loader: () => import("@/layouts/pdf_reporting/academic_post92_check/AcademicPost92CheckReport.vue"), loadingComponent: LoadingSpinner, delay: 200 }),
    CustomTabs,
    SlideTabComponent,
    CustomerProfile,
    AuditTrail
  },
  data: () => ({
    current_tab: "Profile",
    first_name: "",
    last_name: "",
    email: "",
    reference: "",
    phone_number: "",
    date_joined: "",
    id_number: "",
    audit_trails: [],
    documents: [],
    riskDataMap: { risk_data: [] },
    risk_data: { severity: 'unknown', total_score: 0 },
    current_sub_tab: "CreditBureau",
    tabs: [
      { label: 'Profile', value: 'Profile' },
      { label: 'Audit Trails', value: 'AuditTrail' },
      { label: 'Service Completed', value: 'ServiceCompleted' },
      { label: 'Employee Screening', value: 'EmployeeScreening' },
      { label: 'Documents', value: 'Documents' }
    ],
    sub_tabs: [
      { label: 'Credit Bureau', value: 'CreditBureau' },
      { label: 'System Generated', value: 'SystemGenerated' },
      { label: 'Background Screening', value: 'background_screening' }
    ],
    indicatorStyle: {
      width: '0px',
      left: '0px'
    },
    active_credit_bureau_service: null,
    active_system_generated_service: null,
    credit_bureau_services: [],
    system_generated_services: { services: [] },
    financial_services: [],
    selected_document: null,
    selected_document_url: null,
    customer_image: "",
    on_behalf_info: null,
    customer_image_base_64: null,
    incomplete_services: {},

    // New tab for risk assessment
    show_risk_matrix: false,
    selected_service_for_risk: null,
    overall_severity: null,
    is_service_loading: true,
    is_customer_data_visible: false,
    // Customer Terms and Conditions
    trust_data: null,
    customerApplicationId: null,
    // Document risk matrix state
    show_document_risk_matrix: false,
    selected_document_for_risk: null,
    document_overall_severity: 'Unknown',
    // CIPC Plus Score service ID from backend
    cipc_plus_score_service_id_from_api: null,
    // Experian Credit Report service ID from backend
    experian_credit_report_service_id_from_api: null,
  }),
  computed: {
    severity_class() {
      if (!this.overall_severity) return "bg-secondary";
      switch (this.overall_severity.toLowerCase()) {
        case "high":
          return "bg-danger";
        case "medium":
          return "bg-warning text-dark";
        case "low":
          return "bg-success";
        default:
          return "bg-secondary";
      }
      
    },

    document_severity_class() {
      if (!this.document_overall_severity) return "bg-secondary";
      switch (this.document_overall_severity.toLowerCase()) {
        case "high":
          return "bg-danger";
        case "medium":
          return "bg-warning text-dark";
        case "low":
          return "bg-success";
        default:
          return "bg-secondary";
      }
    },

    // Get the service_id for CIPC Plus Score (from API response)
    cipc_plus_score_service_id() {
      return this.cipc_plus_score_service_id_from_api;
    },

    // Get the service_id for Experian Credit Report (from API response)
    experian_credit_report_service_id() {
      return this.experian_credit_report_service_id_from_api;
    },

    // Check if risk assessment is available for CIPC Plus Score
    has_document_risk() {
      return !!this.document_overall_severity && 
             String(this.document_overall_severity).toLowerCase() !== 'unknown' &&
             !!this.cipc_plus_score_service_id;
    },

    nm_results() {
      const get_aml = this.credit_bureau_services.find(
        (service) =>
          (service.service_name === "Anti Money Laundering" ||
            service.service_name === "Search FCRA") &&
          service.response &&
          service.response.Fields?.Applicants_IO?.Applicant?.[0]?.Attributes
            ?.DSWatchlistVerification
      );
      return get_aml?.response?.Fields?.Applicants_IO?.Applicant?.[0]
        ?.Attributes?.DSWatchlistVerification?.NmResults;
    },
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
    selected_service_result() {
      if (this.current_sub_tab === "CreditBureau") {
        if (Array.isArray(this.credit_bureau_services)) {
          return this.credit_bureau_services.find(
            (service) => service.name === this.active_credit_bureau_service
          )?.result;
        }
      } else if (this.current_sub_tab === "SystemGenerated") {
        if (Array.isArray(this.system_generated_services?.services)) {
          return this.system_generated_services.services.find(
            (service) => service.name === this.active_system_generated_service
          )?.questions;
        }
      }
      return null;
    },
    processed_policy_details() {
      return this.preprocess_data(this.policy_details);
    },

    overall_severity_class() {
      if (!this.risk_data || !this.risk_data.severity) {
        return this.get_severity_class('unknown');
      }
      return this.get_severity_class(this.risk_data.severity);
    },
    marker_style() {
      const max_score = 100;
      const totalScore = this.risk_data?.total_score || 0;
      const position = Math.min(
        Math.max((totalScore / max_score) * 100, 0),
        100
      );
      return {
        left: `${position}%`,
      };
    },
    get_user_id() {
      return this.$route.params.id;
    },

    get_customer_application_id() {
      return this.$route.params.application;
    },
    all_credit_bureau_services() {
      const completed_services = Array.isArray(this.credit_bureau_services) ? this.credit_bureau_services : [];
      const unavailable_services = Array.isArray(this.incomplete_services)
        ? this.incomplete_services
        : Object.values(this.incomplete_services || {});

      const filtered_unavailable = unavailable_services.filter(s => s.retry_available);

      const isNamibiaReport = (s) => {
        const name = (s.service_name || '').toLowerCase();
        return name.includes('credit report namibia');
      };

      return [
        ...completed_services.filter(s => !isNamibiaReport(s)),
        ...filtered_unavailable.filter(s => !isNamibiaReport(s))
      ];
    }
  },
  methods: {
    namibia_pdf_url(data) {
      if (!data) return null;
      const url =
        data.pdf_url || data.url_link || data.URL_LINK || data.PDF_URL ||
        data.response?.url_link || data.response?.pdf_url ||
        (Array.isArray(data.result) && data.result.length
          ? data.result[0].URL_LINK || data.result[0].url_link || data.result[0].pdf_url
          : null);
      return url && typeof url === 'string' && url.startsWith('http') ? url : null;
    },
    get_selected_trust() {
      const token = localStorage.getItem("token");
      const base_url = API_BASE_URL;
      const customer_id = this.$route.params.id;
      const get_selected_trust_url = `${base_url}/verify_api/compliance_verification/get_selected_trust/${customer_id}/${this.workflow_id}/`;

      $.ajax({
        method: "GET",
        url: get_selected_trust_url,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${token}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          if (response.status === "success" && response.data) {
            const parsedTrustData = response.data.map(item => {
              let parsed = item;
              if (item && typeof item.trust_data === 'string') {
                let fixed = item.trust_data
                  .replace(/'/g, '"')
                  .replace(/\bNone\b/g, 'null');
                try {
                  parsed = { ...item, trust_data: JSON.parse(fixed) };
                } catch (e) {
                  parsed = { ...item, trust_data: [] };
                }
              }
              return parsed;
            });
            this.trust_data = parsedTrustData;
          }
        }
      })
    },
    aml_results(result) {
      const aml_result =
        result?.Fields?.Applicants_IO?.Applicant?.[0]?.Attributes
          ?.DSWatchlistVerification;
      var request_data = result?.RequestData || {};

      if (!aml_result) return { RequestData: request_data };

      return {
        RequestData: request_data,
        NmResults: aml_result?.NmResults || [],
        PepResults: aml_result?.PepResults || [],
        WlsResults: aml_result?.WlsResults || [],
      };
    },
    response_info_aml(result) {
      const response_info_result = result?.ResponseInfo;
      if (!response_info_result) return {};
      return response_info_result;
    },
    date_scored(result) {
      const date_scored_result =
        result?.Fields?.Applicants_IO?.Applicant?.[0]?.Attributes
          ?.DRWatchlistVerification;
      if (!date_scored_result) return "";
      return date_scored_result?.TimeOfRequest || "";
    },

    handleServiceClick(service) {
      // Switch to Service Completed tab to show the risk assessments
      this.current_tab = 'ServiceCompleted';

      const candidateIds = [service.service_id, service.id]
        .filter(id => id !== undefined && id !== null)
        .map(id => String(id));

      const matchById = item => {
        const itemCandidates = [item?.service_id, item?.id, item?.form_id]
          .filter(id => id !== undefined && id !== null)
          .map(id => String(id));
        return candidateIds.length > 0 && itemCandidates.some(id => candidateIds.includes(id));
      };

      const creditServices = Array.isArray(this.credit_bureau_services) ? this.credit_bureau_services : [];
      let creditService = creditServices.find(item => matchById(item));

      const systemServices = Array.isArray(this.system_generated_services?.services)
        ? this.system_generated_services.services
        : [];
      let systemService = systemServices.find(item => matchById(item));

      if (!creditService) {
        creditService = creditServices.find(item =>
          (item?.service_name || '').toLowerCase() === (service?.service_name || '').toLowerCase()
        );
      }

      if (!systemService) {
        systemService = systemServices.find(item =>
          (item?.service_name || '').toLowerCase() === (service?.service_name || '').toLowerCase()
        );
      }

      const isSystemGeneratedService = Boolean(systemService) ||
        (service?.service_type && service.service_type.toLowerCase() === 'custom_form');

      const targetService = creditService || systemService || service;

      // Set the appropriate sub-tab
      if (isSystemGeneratedService) {
        this.current_sub_tab = 'SystemGenerated';
      } else {
        this.current_sub_tab = 'CreditBureau';
      }

      this.$nextTick(() => {
        try {
          const resolvedServiceName = targetService?.service_name || service?.service_name;
          if (resolvedServiceName) {
            this.toggle_service(resolvedServiceName);

            if (this.current_sub_tab === 'CreditBureau') {
              this.active_credit_bureau_service = resolvedServiceName;
            } else if (this.current_sub_tab === 'SystemGenerated') {
              this.active_system_generated_service = resolvedServiceName;
            }
          }

          const severityIdentifier = targetService?.service_id || targetService?.id || candidateIds[0];
          if (severityIdentifier) {
            const numericId = Number(severityIdentifier);
            const resolvedIdentifier = Number.isNaN(numericId) ? severityIdentifier : numericId;
            if (this.current_sub_tab === 'CreditBureau') {
              this.get_service_overall_severity(resolvedIdentifier);
            } else {
              this.get_overall_severity(resolvedIdentifier);
            }
          }

          // Small delay to ensure service is expanded before opening risk matrix
          setTimeout(() => {
            try {
              this.toggle_risk_matrix(targetService);
            } catch (e) {
              this.selected_service_for_risk = targetService;
              this.show_risk_matrix = true;
            }
          }, 300);
        } catch (e) {
          console.error('Error opening risk assessment:', e);
        }
      });
    },

    toggle_risk_matrix(service) {
      // If clicking on the same service, just toggle visibility
      if (this.selected_service_for_risk && this.selected_service_for_risk.id === service.id) {
        this.show_risk_matrix = !this.show_risk_matrix;
      } else {
        // If clicking on a different service, set it as selected and show matrix
        this.selected_service_for_risk = service;
        this.show_risk_matrix = true;
      }
    },

    toggle_document_risk_matrix(document) {
      // If clicking on the same document, just toggle visibility
      if (this.selected_document_for_risk && this.selected_document_for_risk.id === document.id) {
        this.show_document_risk_matrix = !this.show_document_risk_matrix;
      } else {
        // If clicking on a different document, set it as selected and show matrix
        this.selected_document_for_risk = document;
        this.show_document_risk_matrix = true;
      }
    },

    get_document_overall_severity(document) {
      // Only fetch severity for CIPC plus score or Experian Credit Report documents
      if (document.document_type !== 'cipc_plus_score' && document.document_type !== 'experian_credit_report') {
        return;
      }

      // Get the service_id based on document type
      let service_id = null;
      if (document.document_type === 'cipc_plus_score') {
        service_id = this.cipc_plus_score_service_id;
      } else if (document.document_type === 'experian_credit_report') {
        service_id = this.experian_credit_report_service_id;
      }
      
      if (!service_id) {
        this.document_overall_severity = 'Unknown';
        return;
      }
      
      this.show_document_risk_matrix = false;
      this.selected_document_for_risk = null;
      const token = localStorage.getItem("token");
      const base_url = API_BASE_URL;
      const customer_id = this.$route.params.id;
      const customer_application = this.$route.params.application;
      const url = `${base_url}/verify_api/workflow_management_api/get_overall_service_severity/${service_id}/${customer_id}/${customer_application}/`;

      $.ajax({
        method: "GET",
        url: url,
        headers: { Authorization: `Token ${token}` },
        success: (response) => {
          this.document_overall_severity = response.severity || 'Unknown';
        },
        error: () => {
          this.document_overall_severity = 'Unknown';
        },
      });
    },

    handle_document_risk_update(risk_data) {
      this.document_overall_severity = risk_data.severity;
    },

    autoExpandCipcPlusScoreDocument(retries = 10, delayMs = 200) {
    
      const cipcDocument = this.documents.find(
        doc => doc.document_type === 'cipc_plus_score'
      );

      if (cipcDocument) {

        this.selected_document = cipcDocument;
       
        this.get_document_overall_severity(cipcDocument);

        this.$nextTick(() => {
          setTimeout(() => {
            this.toggle_document_risk_matrix(cipcDocument);
          }, 100);
        });
      } else if (retries > 0) {
      
        setTimeout(() => {
          this.autoExpandCipcPlusScoreDocument(retries - 1, delayMs);
        }, delayMs);
      }
    },

    reset_risk_matrix_state() {
      this.show_risk_matrix = false;
      this.selected_service_for_risk = null;
      this.overall_severity = 'Unknown';
    },

    toggle_service(service_name) {
      this.reset_risk_matrix_state();

      if (this.current_sub_tab === "CreditBureau") {
        this.active_credit_bureau_service =
          this.active_credit_bureau_service === service_name
            ? null
            : service_name;
      } else if (this.current_sub_tab === "SystemGenerated") {
        this.active_system_generated_service =
          this.active_system_generated_service === service_name
            ? null
            : service_name;
      }
    },

    validate_inputs() {
      if (!validate_email(this.email)) return false;
      if (!validate_phone_number(this.phone_number)) return false;
      return true;
    },

    get_workflow_id() {
      try {
        this.workflow_id = this.store_workflow_id || 0;
      } catch (error) {
        this.workflow_id = 0;
      }
    },

    async get_customer_data() {
      const token = localStorage.getItem("token");
      const customer_id = this.$route.params.id;
      const customer_application = this.$route.params.application;

      try {
        const data = await fetchCustomerData({ customer_id, customer_application, token });
        
        this.id_number = data.id_number;
        this.first_name = data.first_name;
        this.last_name = data.last_name;
        this.email = data.email;
        this.reference = data.reference;
        this.phone_number = data.phone_number;
        this.date_joined = data.date_joined;
        this.audit_trails = data.audit_trails;
        this.documents = data.documents;
        this.is_iframe_visible = new Array(data.documents.length).fill(false);
        this.customerApplicationId = customer_application;
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: error.responseJSON.error,
          confirmButtonText: "OK",
        });
      }
    },

  getPercentage(service) {
    if (!service.max_possible_score || service.max_possible_score === 0) return 0;
    return Math.round((service.total_score / service.max_possible_score) * 100);
  },

  getSeverityClass(severity) {
      return `severity-${severity ? severity.toLowerCase() : 'unknown'}`;
  },

  getPercentageClass(service) {
      return `percentage-${service.severity ? service.severity.toLowerCase() : 'unknown'}`;
  },

  getProgressClass(service) {
      return `progress-${service.severity ? service.severity.toLowerCase() : 'unknown'}`;
  },

  deriveServiceCategory(service) {
      if (!service) {
        return null;
      }

      if (service.service_category) {
        return service.service_category;
      }

      const name = (service.service_name || '').toLowerCase().trim();
      if (!name) {
        return null;
      }

      if (name.includes('academic post 92')) {
        return 'background_screening';
      }

      if (name.includes('academic') && name.includes('check')) {
        return 'background_screening';
      }

      return 'CreditBureau';
  },

    loadCustomersRiskData() {
      const TOKEN = localStorage.getItem('token');

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/customers_scores/`,
        method: 'GET',
        contentType: 'application/json',
        headers: { Authorization: `Token ${TOKEN}` },
        data: {
          workflow_id: this.workflow_id,
          customer_application: this.$route.params.application,
        },
        success: (response) => {
          if (response.status === 'success' && response.data && response.data.length) {
            const latestApp = response.data.reduce((latest, app) => {
              return !latest || app.application_id > latest.application_id ? app : latest;
            }, null);

            this.riskDataMap = {
              risk_loading: false,
              risk_data: latestApp?.services || [],
              risk_error: latestApp ? null : 'No risk data'
            };
          } else {
            this.riskDataMap = {
              risk_loading: false,
              risk_data: [],
              risk_error: 'No risk data'
            };
          }
        },
        error: (xhr, status, err) => {
          console.error("Error loading risk data:", err);
          this.riskDataMap = {
            risk_loading: false,
            risk_data: [],
            risk_error: "Failed to load risk data"
          };
        }
      });
    },

    get_asset_info() {
      const token = localStorage.getItem("token");
      const base_url = API_BASE_URL;
      const customer_application = this.$route.params.application;

      const url = `${base_url}/verify_api/customer_management_api/get_asset_application_info/${customer_application}/`;

      $.ajax({
        method: "GET",
        url: url,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${token}`,
        },
        success: (response) => {
          if (response.status === "success" && response.asset_data) {
            this.asset_info = response.asset_data;
          }
        },
        error: (xhr) => {
          console.error("Error fetching asset info:", xhr);
          this.asset_info = null;
        },
      });
    },

    toggle_iframe(document) {
      this.selected_document =
        this.selected_document && this.selected_document.id === document.id
          ? null
          : document;
    },

    show_document(url) {
      this.selected_document_url =
        this.selected_document_url === url ? null : url;
    },
    get_customer_service_responses() {
      const token = localStorage.getItem("token");
      const base_url = API_BASE_URL;

      if (!base_url) {
        show_error(
          ".error-message",
          "Server configuration error. Please try again later."
        );
        return;
      }

      const customer_id = this.$route.params.id;
      const customer_application = this.$route.params.application;
      const get_service_responses = `${base_url}/verify_api/workflow_management_api/get_customer_service_responses/${customer_id}/${customer_application}/`;

      $.ajax({
        method: "GET",
        url: get_service_responses,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${token}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          this.system_generated_services = response.system_generated || {};
          this.credit_bureau_services = response.credit_bureau || [];
          this.incomplete_services = response.incomplete_services || {};
          this.financial_services = response.financial_services || {};
          this.customer_image = response.customer_image;
          this.customer_image_base_64 = response.customer_image_base_64;
          // Store CIPC Plus Score service ID from backend
          this.cipc_plus_score_service_id_from_api = response.cipc_plus_score_service_id || null;
          // Store Experian Credit Report service ID from backend
          this.experian_credit_report_service_id_from_api = response.experian_credit_report_service_id || null;

          // Check if we need to open risk assessment from route after services are loaded
          this.$nextTick(() => {
            const query = this.$route.query || {};
            if (query.showRisk === '1' && query.serviceId) {
              this.checkAndOpenRiskFromRoute();
            }
          });
        },
        error: () => {
          Swal.close();
          this.system_generated_services = {};
          this.credit_bureau_services = [];
          this.incomplete_services = {};
          this.financial_services = {};
          
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load customer service responses. Please try again.",
          });
        },
        complete: () => {
          this.is_service_loading = false; // stop spinner whether success or error
        },
      });
    },

    checkAndOpenRiskFromRoute(retries = 5, delayMs = 150) {
      const query = this.$route.query || {};
      if (!query.showRisk || query.showRisk !== '1' || !query.serviceId) return;

      // Check if services are loaded, if not, wait for them
      const servicesLoaded = this.credit_bureau_services && this.system_generated_services;
      if (!servicesLoaded) {
        return;
      }

      const serviceId = parseInt(query.serviceId, 10);
      const serviceType = query.serviceType; // Get service type from query

      const requestedTab = query.tab;

      const attemptOpen = (remaining) => {
        
        if (requestedTab === 'Documents') {
          this.current_tab = 'Documents';

          this.$nextTick(() => {
            this.autoExpandCipcPlusScoreDocument();
          });
          return; 
        }

        this.current_tab = 'ServiceCompleted';
        
        // Set initial sub-tab based on serviceType if provided
        if (serviceType === 'CreditBureau') {
          this.current_sub_tab = 'CreditBureau';
        } else if (serviceType === 'SystemGenerated') {
          this.current_sub_tab = 'SystemGenerated';
        } else if (serviceType === 'background_screening') {
          this.current_sub_tab = 'background_screening';
        } else {
          // Default to CreditBureau if not specified
          this.current_sub_tab = 'CreditBureau';
        }

        if (this.current_sub_tab === 'background_screening') {
          // Academic checks are managed within the background screening tab;
          // no risk matrix needs to be opened.
          return;
        }

        let targetService = null;
        let serviceSource = null;

        // Check credit bureau services first
        if (Array.isArray(this.credit_bureau_services)) {
          targetService = this.credit_bureau_services.find(s => s.service_id === serviceId || s.id === serviceId);
          if (targetService) {
            serviceSource = 'CreditBureau';
          }
        }

        // Check system generated services
        if (!targetService && Array.isArray(this.system_generated_services?.services)) {
          targetService = this.system_generated_services.services.find(s => s.service_id === serviceId || s.id === serviceId);
          if (targetService) {
            serviceSource = 'SystemGenerated';
            this.current_sub_tab = 'SystemGenerated';
          }
        }

        // Fallback to riskDataMap if not found in specific service lists
        if (!targetService && this.riskDataMap && Array.isArray(this.riskDataMap.risk_data)) {
          targetService = this.riskDataMap.risk_data.find(s => s.service_id === serviceId || s.id === serviceId);
          if (targetService) {
            const derivedCategory = this.deriveServiceCategory(targetService);

            if (derivedCategory === 'background_screening') {
              this.current_sub_tab = 'background_screening';
              return;
            }

            serviceSource = derivedCategory === 'SystemGenerated' ? 'SystemGenerated' : 'CreditBureau';
          }
        }

        if (targetService) {
          const serviceCategory = this.deriveServiceCategory(targetService);
          if (serviceCategory === 'background_screening') {
            this.current_sub_tab = 'background_screening';
            return;
          }

          this.$nextTick(() => {
            try {
              // Set active service directly without calling toggle_service to avoid reset
              if (serviceSource === 'CreditBureau' || this.current_sub_tab === 'CreditBureau') {
                this.active_credit_bureau_service = targetService.service_name || targetService.name;
              } else if (serviceSource === 'SystemGenerated' || this.current_sub_tab === 'SystemGenerated') {
                this.active_system_generated_service = targetService.service_name || targetService.name;
              }

              if (targetService.service_id) {
                this.get_service_overall_severity(targetService.service_id);
              }

              setTimeout(() => {
                try {
                  this.toggle_risk_matrix(targetService);
                } catch (e) {
                  this.selected_service_for_risk = targetService;
                  this.show_risk_matrix = true;
                }
              }, 200);
              
            } catch (e) {
              console.error('Error opening service:', e);
            }
          });
          return;
        }

        if (remaining > 0) {
          setTimeout(() => attemptOpen(remaining - 1), delayMs);
          return;
        }

        console.warn('Requested service not found to open risk matrix after retries:', serviceId);
      };

      attemptOpen(retries);
    },

    format_questions(questions) {
      if (typeof questions === "string") {
        try {
          // Attempt to parse as JSON
          questions = JSON.parse(questions.replace(/'/g, '"'));
        } catch (error) {
          // Keep silent
        }
      }
      return questions;
    },
    format_label(key) {
      if (typeof key !== "string" || !key.trim()) return "";

      return key
        .replace(/[_-]/g, " ")
        .replace(/[^a-zA-Z0-9]/g, " ") // Replace non-alphanumeric characters with a space
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters following a lowercase letter
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2") // Add space between consecutive uppercase letters followed by a lowercase
        .replace(/\s+/g, " ") // Replace multiple spaces with a single space
        .trim() // Trim leading/trailing spaces
        .split(" ") // Split the string into words
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ) // Capitalize the first letter of each word
        .join(" "); // Join the words back into a single string
    },
    preprocess_data(data, parent_key = "", service_name = "") {
      let result = [];
      const handledPaths = new Set();

      for (const rule of serviceRules) {
        const handled = rule.call(this, data, service_name);
        if (Array.isArray(handled) && handled.length > 0) {
          result.push(...handled);
          if (Array.isArray(rule.handledKeys)) {
            rule.handledKeys.forEach((key) => handledPaths.add(key));
          }
        }
      }
      const isHandled = (path) => {
        for (const handled of handledPaths) {
          if (
            path === handled ||
            path.startsWith(handled + ".") ||
            path.startsWith(handled + "[")
          ) {
            return true;
          }
        }
        return false;
      };
      const defaultResult = defaultDataProcessing(
        data,
        parent_key,
        service_name,
        this.format_label,
        isHandled
      );
      result.push(...defaultResult);
      return result;
    },

    format_auth_value(item) {
      if (item.key && item.key.includes("document_authenticity")) {
        if (item.value === 1) return "Passed";
        if (item.value === 0) return "Failed";
        if (item.value === 2) return "Not Checked";
        return "Unknown";
      }
      return item.value || "None";
    },
    get_severity_class(severity) {
      switch (severity.toLowerCase()) {
        case "high":
          return "bg-danger";
        case "medium":
          return "bg-warning text-dark";
        case "low":
          return "bg-success";
        default:
          return "bg-secondary";
      }
    },

    handle_risk_update(risk_data) {
      this.overall_severity = risk_data.severity;
    },

    get_overall_severity(service_id) {
      this.show_risk_matrix = false;
      this.selected_service_for_risk = null;
      const token = localStorage.getItem("token");
      const base_url = API_BASE_URL;
      const customer_id = this.$route.params.id;
      const customer_application = this.$route.params.application;
      const url = `${base_url}/verify_api/workflow_management_api/get_overall_severity/${service_id}/${customer_id}/${customer_application}/`;

      $.ajax({
        method: "GET",
        url: url,
        headers: { Authorization: `Token ${token}` },
        success: (response) => {
          this.overall_severity = response.severity;
        },
        error: () => {
          // Silent error handling
        },
      });
    },

    get_service_overall_severity(service_id) {
      this.show_risk_matrix = false;
      this.selected_service_for_risk = null;
      const token = localStorage.getItem("token");
      const base_url = API_BASE_URL;
      const customer_id = this.$route.params.id;
      const customer_application = this.$route.params.application;
      const url = `${base_url}/verify_api/workflow_management_api/get_overall_service_severity/${service_id}/${customer_id}/${customer_application}/`;

      $.ajax({
        method: "GET",
        url: url,
        headers: { Authorization: `Token ${token}` },
        success: (response) => {
          this.overall_severity = response.severity;
        },
        error: () => { },
      });
    },

    async download_custom_form(service) {
      this.loading = true;

      // Validate service data
      if (!service || !service.questions || service.questions.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Data Available",
          text: "No questions found for this service. Please ensure the service contains valid data.",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Got it",
          showConfirmButton: true,
        });
        this.loading = false;
        return;
      }

      Swal.fire({
        title: 'Generating Professional Service Report...',
        text: 'Please wait while we prepare your comprehensive service assessment report.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      try {
        // Initialize PDF document with professional settings
        const doc = new jsPDF("p", "mm", "a4");

        // Enhanced document properties
        doc.setProperties({
          title: `${service.service_name} Assessment Report`,
          subject: `Comprehensive ${service.service_name} Analysis and Assessment`,
          author: "Service Assessment System",
          keywords: `${service.service_name}, Service Assessment, Analysis Report, Data Review`,
          creator: "Enterprise Service Management Platform",
          producer: "jsPDF Service Analytics Module"
        });

        // Professional color palette (same as risk summary)
        const colors = {
          primary: [25, 118, 210],      // blue
          secondary: [55, 71, 79],      // grey
          accent: [76, 175, 80],        // green
          danger: [244, 67, 54],        // High risk red
          warning: [255, 193, 7],       // Medium risk orange
          info: [33, 150, 243],         // Info blue
          light: [248, 250, 252],       // Light background
          border: [224, 224, 224],      // Border color
          text: [33, 33, 33],           // Primary text
          textSecondary: [117, 117, 117] // Secondary text
        };

        const typography = {
          h1: { size: 24, weight: "bold", color: colors.primary },
          h2: { size: 18, weight: "bold", color: colors.secondary },
          h3: { size: 14, weight: "bold", color: colors.secondary },
          h4: { size: 12, weight: "bold", color: colors.secondary },
          body: { size: 10, weight: "normal", color: colors.text },
          caption: { size: 8, weight: "normal", color: colors.textSecondary },
          tableHeader: { size: 9, weight: "bold", color: [255, 255, 255] },
          tableBody: { size: 8, weight: "normal", color: colors.text }
        };

        const layout = {
          pageWidth: doc.internal.pageSize.getWidth(),
          pageHeight: doc.internal.pageSize.getHeight(),
          margin: 20,
          headerHeight: 25,
          footerHeight: 15,
          sectionSpacing: 15,
          cardPadding: 10
        };

        layout.contentWidth = layout.pageWidth - (layout.margin * 2);
        layout.contentHeight = layout.pageHeight - layout.headerHeight - layout.footerHeight - (layout.margin * 2);

        let currentY = layout.margin + layout.headerHeight;

        // Enhanced header and footer function
        const addHeaderFooter = (pageNum, totalPages) => {
          doc.setFillColor(colors.primary[0], colors.primary[1], colors.primary[2]);
          doc.rect(0, 0, layout.pageWidth, layout.headerHeight, 'F');

          // Add subtle gradient effect (simulated with overlapping rectangles)
          doc.setFillColor(colors.primary[0] + 10, colors.primary[1] + 10, colors.primary[2] + 10);
          doc.rect(0, 0, layout.pageWidth, layout.headerHeight / 2, 'F');

          // Header content
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(typography.h3.size);
          doc.setFont(undefined, typography.h3.weight);
          doc.text("SERVICE ASSESSMENT REPORT", layout.margin, 12);

          // Service identifier in header
          doc.setFontSize(typography.caption.size);
          doc.text("SERVICE MANAGEMENT SYSTEM", layout.pageWidth - layout.margin, 12, { align: "right" });

          // Header divider line
          doc.setDrawColor(255, 255, 255);
          doc.setLineWidth(0.5);
          doc.line(layout.margin, layout.headerHeight - 2, layout.pageWidth - layout.margin, layout.headerHeight - 2);

          // Professional footer
          doc.setFillColor(colors.light[0], colors.light[1], colors.light[2]);
          doc.rect(0, layout.pageHeight - layout.footerHeight, layout.pageWidth, layout.footerHeight, 'F');

          doc.setTextColor(colors.textSecondary[0], colors.textSecondary[1], colors.textSecondary[2]);
          doc.setFontSize(typography.caption.size);
          doc.setFont(undefined, "normal");

          // Footer left - Generation info
          const generationTime = new Date().toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          });
          doc.text(`Generated: ${generationTime}`, layout.margin, layout.pageHeight - 5);

          // Footer center - Confidentiality notice
          doc.text("CONFIDENTIAL", layout.pageWidth / 2, layout.pageHeight - 5, { align: "center" });

          // Footer right - Pagination
          doc.text(`Page ${pageNum} of ${totalPages}`, layout.pageWidth - layout.margin, layout.pageHeight - 5, { align: "right" });

          // Footer divider line
          doc.setDrawColor(colors.border[0], colors.border[1], colors.border[2]);
          doc.setLineWidth(0.5);
          doc.line(layout.margin, layout.pageHeight - layout.footerHeight + 2, layout.pageWidth - layout.margin, layout.pageHeight - layout.footerHeight + 2);

          // Reset colors
          doc.setTextColor(colors.text[0], colors.text[1], colors.text[2]);
        };

        // Enhanced title section with professional styling
        currentY = layout.headerHeight + 25;

        // Main title with enhanced styling
        doc.setFontSize(typography.h1.size);
        doc.setFont(undefined, typography.h1.weight);
        doc.setTextColor(colors.primary[0], colors.primary[1], colors.primary[2]);
        doc.text(service.service_name.toUpperCase(), layout.pageWidth / 2, currentY, { align: "center" });

        currentY += 8;
        doc.setFontSize(typography.h2.size);
        doc.setFont(undefined, "normal");
        doc.setTextColor(colors.secondary[0], colors.secondary[1], colors.secondary[2]);
        doc.text("SERVICE ASSESSMENT REPORT", layout.pageWidth / 2, currentY, { align: "center" });

        currentY += 20;

        // Professional report metadata box
        doc.setFillColor(colors.light[0], colors.light[1], colors.light[2]);
        doc.setDrawColor(colors.border[0], colors.border[1], colors.border[2]);
        doc.setLineWidth(0.5);
        doc.rect(layout.margin, currentY, layout.contentWidth, 35, 'FD');

        currentY += 12;
        doc.setFontSize(typography.body.size);
        doc.setFont(undefined, "normal");
        doc.setTextColor(colors.text[0], colors.text[1], colors.text[2]);

        // Report metadata in two columns
        const reportDate = new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });

        doc.text(`Report Date: ${reportDate}`, layout.margin + 10, currentY);
        doc.text(`Service Name: ${service.service_name}`, layout.margin + 10, currentY + 6);
        doc.text(`Total Questions: ${service.questions.length}`, layout.margin + 10, currentY + 12);

        // Right column
        const rightColumnX = layout.pageWidth / 2 + 10;
        doc.text(`Report Type: Service Assessment`, rightColumnX, currentY);
        doc.text(`Assessment Status: Complete`, rightColumnX, currentY + 6);
        doc.text(`Data Quality: Verified`, rightColumnX, currentY + 12);

        currentY += 40;

        // Enhanced summary statistics with professional styling
        const totalQuestions = service.questions.length;
        const answeredQuestions = service.questions.filter(q => q.response && q.response.toString().trim() !== '').length;
        const responseRate = totalQuestions > 0 ? ((answeredQuestions / totalQuestions) * 100).toFixed(1) : 0;

        // Executive Summary section with enhanced styling
        doc.setFillColor(colors.secondary[0], colors.secondary[1], colors.secondary[2]);
        doc.rect(layout.margin, currentY, layout.contentWidth, 8, 'F');

        doc.setFontSize(typography.h3.size);
        doc.setFont(undefined, typography.h3.weight);
        doc.setTextColor(255, 255, 255);
        doc.text("EXECUTIVE SUMMARY", layout.margin + 10, currentY + 6);

        currentY += 30;

        // Statistics cards
        const cardWidth = (layout.contentWidth - 30) / 3;
        const cardHeight = 18;

        const valueY = currentY + cardHeight / 2; // Number (visually centered)
        const labelY = currentY + cardHeight / 2 + 4; // Label (slightly below number)

        // Total Questions Card
        doc.setFillColor(...colors.primary);
        doc.rect(layout.margin, currentY, cardWidth, cardHeight, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(typography.h1.size);
        doc.setFont(undefined, "bold");
        doc.text(totalQuestions.toString(), layout.margin + cardWidth / 2, valueY, { align: "center" });
        doc.setFontSize(typography.caption.size);
        doc.text("TOTAL QUESTIONS", layout.margin + cardWidth / 2, labelY, { align: "center" });

        // Answered Questions Card
        const secondCardX = layout.margin + cardWidth + 15;
        doc.setFillColor(...colors.accent);
        doc.rect(secondCardX, currentY, cardWidth, cardHeight, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(typography.h1.size);
        doc.text(answeredQuestions.toString(), secondCardX + cardWidth / 2, valueY, { align: "center" });
        doc.setFontSize(typography.caption.size);
        doc.text("ANSWERED", secondCardX + cardWidth / 2, labelY, { align: "center" });

        // Response Rate Card
        const thirdCardX = layout.margin + (cardWidth + 15) * 2;
        const responseColor = responseRate >= 80 ? colors.accent : responseRate >= 60 ? colors.warning : colors.danger;
        doc.setFillColor(...responseColor);
        doc.rect(thirdCardX, currentY, cardWidth, cardHeight, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(typography.h1.size);
        doc.text(`${responseRate}%`, thirdCardX + cardWidth / 2, valueY, { align: "center" });
        doc.setFontSize(typography.caption.size);
        doc.text("RESPONSE RATE", thirdCardX + cardWidth / 2, labelY, { align: "center" });

        currentY += 30;

        // Enhanced summary statistics table
        const summaryData = [
          ["Metric", "Value", "Status"],
          ["Total Questions", totalQuestions.toString(), "Complete"],
          ["Answered Questions", answeredQuestions.toString(), answeredQuestions === totalQuestions ? "Complete" : "Partial"],
          ["Response Rate", `${responseRate}%`, responseRate >= 80 ? "Excellent" : responseRate >= 60 ? "Good" : "Needs Improvement"],
        ];

        autoTable(doc, {
          head: [summaryData[0]],
          body: summaryData.slice(1),
          theme: "grid",
          startY: currentY,
          styles: {
            fontSize: typography.tableBody.size,
            cellPadding: 4,
            overflow: "linebreak",
            lineColor: colors.border,
            lineWidth: 0.5,
            textColor: colors.text
          },
          headStyles: {
            fillColor: colors.secondary,
            textColor: [255, 255, 255],
            fontSize: typography.tableHeader.size,
            fontStyle: "bold",
            halign: "center"
          },
          alternateRowStyles: {
            fillColor: colors.light,
          },
          margin: { left: layout.margin, right: layout.margin },
          columnStyles: {
            0: { cellWidth: layout.contentWidth * 0.4, fontStyle: "bold" },
            1: { cellWidth: layout.contentWidth * 0.3, halign: "center" },
            2: { cellWidth: layout.contentWidth * 0.3, halign: "center", fontStyle: "bold" }
          },
          didParseCell: function (data) {
            if (data.row.index >= 0 && data.column.index === 2) {
              const status = data.cell.raw;
              if (status === "Complete" || status === "Excellent") {
                data.cell.styles.textColor = colors.accent;
              } else if (status === "Good" || status === "Partial") {
                data.cell.styles.textColor = colors.warning;
              } else if (status === "Needs Improvement") {
                data.cell.styles.textColor = colors.danger;
              }
            }
          }
        });

        // Add new page for detailed questions and answers
        doc.addPage();
        currentY = layout.headerHeight + 20;

        // Detailed analysis section header
        doc.setFillColor(colors.secondary[0], colors.secondary[1], colors.secondary[2]);
        doc.rect(layout.margin, currentY, layout.contentWidth, 8, 'F');

        doc.setFontSize(typography.h3.size);
        doc.setFont(undefined, typography.h3.weight);
        doc.setTextColor(255, 255, 255);
        doc.text("DETAILED QUESTIONS & ANSWERS", layout.margin + 10, currentY + 6);

        currentY += 20;

        // Prepare table data for questions and answers
        const tableRows = [];
        service.questions.forEach((item, index) => {
          if (Array.isArray(this.format_questions(item.response))) {
            this.format_questions(item.response).forEach((ans, idx) => {
              tableRows.push([
                idx === 0 ? `${index + 1}. ${item.question}` : "",
                ans || 'No response provided'
              ]);
            });
          } else {
            tableRows.push([
              `${index + 1}. ${item.question}`,
              item.response || 'No response provided'
            ]);
          }
        });

        // Enhanced questions and answers table
        if (tableRows.length > 0) {
          autoTable(doc, {
            head: [["Question", "Answer"]],
            body: tableRows,
            theme: "grid",
            startY: currentY,
            styles: {
              fontSize: typography.tableBody.size,
              cellPadding: 4,
              overflow: "linebreak",
              lineColor: colors.border,
              lineWidth: 0.5,
              textColor: colors.text,
              cellWidth: "wrap"
            },
            headStyles: {
              fillColor: colors.secondary,
              textColor: [255, 255, 255],
              fontSize: typography.tableHeader.size,
              fontStyle: "bold",
              halign: "center"
            },
            alternateRowStyles: {
              fillColor: colors.light,
            },
            margin: { left: layout.margin, right: layout.margin },
            columnStyles: {
              0: {
                cellWidth: layout.contentWidth * 0.4,
                fontStyle: "bold",
                valign: "top"
              },
              1: {
                cellWidth: layout.contentWidth * 0.6,
                valign: "top"
              }
            },
            didParseCell: function (data) {
              // Style empty responses
              if (data.column.index === 1 && data.row.index >= 0) {
                const answer = data.cell.raw;
                if (!answer || answer === 'No response provided') {
                  data.cell.styles.textColor = colors.textSecondary;
                  data.cell.styles.fontStyle = "italic";
                }
              }
            },
            didDrawPage: function () {
              addHeaderFooter(doc.internal.getCurrentPageInfo().pageNumber, doc.internal.getNumberOfPages());
            }
          });
        }

        // Add headers and footers to all pages
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          addHeaderFooter(i, totalPages);
        }

        // Generate professional filename
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[T:]/g, "_");
        const serviceName = service.service_name.replace(/[^a-zA-Z0-9]/g, "_");
        const filename = `Service_Assessment_${serviceName}_${timestamp}.pdf`;

        doc.save(filename);

        Swal.close();

        Swal.fire({
          icon: "success",
          title: "Professional Report Generated!",
          html: `Your comprehensive service assessment report has been generated successfully.<br><br><strong>Service:</strong> ${service.service_name}<br><strong>File:</strong> ${filename}<br><strong>Pages:</strong> ${totalPages}<br><strong>Questions:</strong> ${service.questions.length}`,
          confirmButtonColor: colors.accent.join(','),
          confirmButtonText: "Excellent!",
          timer: 5000,
          showConfirmButton: true,
        });

      } catch (error) {
        console.error("Error generating professional service report:", error);

        Swal.close();

        Swal.fire({
          icon: "error",
          title: "Report Generation Failed",
          text: "An error occurred while generating the professional service report. Please try again or contact technical support.",
          confirmButtonColor: "#dc3545",
          confirmButtonText: "OK",
          showConfirmButton: true,
        });
      } finally {
        this.loading = false;
      }
    },
    handleRerunSuccess(service) {
      this.get_customer_service_responses();
      this.get_customer_data();
      this.active_credit_bureau_service = service.service_name;
    },
    canRerunService(service) {
      if (!this.incomplete_services) return false;
      return this.incomplete_services.some(
        inc =>
          inc.service_name === service.service_name &&
          inc.retry_available
      ) && !service.response;
    },
  },
  watch: {
    current_tab(newTab) {
      // Store the current tab in localStorage
      localStorage.setItem("Profile", newTab);
    }
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_selected_trust();
    this.get_customer_data();
    this.get_customer_service_responses();
    this.$nextTick(() => {
    setTimeout(() => {
      this.checkAndOpenRiskFromRoute();
    }, 500);
  });
  }
};
